
import Vue from "vue";
import notifications from "@/lib/notifications";
import Component from "vue-class-component";
import { RoleListResource } from "../../models/api/system/roles";
import { getModule } from "vuex-module-decorators";
import SystemModule from "@/store/modules/system";
import { FacilityDetailsResource, SaveFacilityDetails } from "@/models/api/system/facilityDetails";
import { Ref } from "vue-property-decorator";
import { formatPhoneNumber } from "@/utils";

const systemModule = getModule(SystemModule);

@Component
export default class FacilityEdit extends Vue {
  loading: boolean = false;
  loadingPage: boolean = false;
  roles: RoleListResource[] = [];
  showStandardized: boolean = false;

  @Ref() readonly validator!: any;

  facilityDetail: FacilityDetailsResource = {
    facilityCode: null,
    builderFacilityCode: null,
    companyName: null,
    internalName: null,
    address: {
      streetLine1: null,
      streetLine2: null,
      city: null,
      state: null,
      zip: null
    },
    standardizedAddress: {
      streetLine1: null,
      streetLine2: null,
      city: null,
      state: null,
      zip: null
    },
    phone: null,
    tollFreePhone: null,
    fax: null,
    customerServicePhone: null,
    inboundSchedulingEmail: null,
    timeZone: null,
    serviceType: null,
    shipperCompanyId: null,
    agentShipperCompanyId: null,
    isCDSFacility: null,
    isCDSOwnedFacility: null,
    carrierCode: null,
    isActive: true,
    isNew: true,
    longitude: null,
    latitude: null,
  };

  async created() {
    this.loadFacility();
  }

  formatPhone(value) {
    const x = value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
    this.$set(this.facilityDetail, 'phone', !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : ''));
  }

  formatTollFreePhone(value) {
    const x = value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
    this.$set(this.facilityDetail, 'tollFreePhone', !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : ''));
  }

  formatCustomerServicePhone(value) {
    const x = value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
    this.$set(this.facilityDetail, 'customerServicePhone', !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : ''));
  }

  formatFaxPhone(value) {
    const x = value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
    this.$set(this.facilityDetail, 'fax', !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : ''));
  }
  
  formattedPhoneNumber(phoneNumber) {
    return phoneNumber ? formatPhoneNumber(phoneNumber) : '';
  }

  async loadFacility() {
    this.loadingPage = true;
    if (this.$route.params.facilityCode)
      this.facilityDetail = await systemModule.getFacilityDetails(this.$route.params.facilityCode);

    this.facilityDetail.phone = this.formattedPhoneNumber(this.facilityDetail.phone);
    this.facilityDetail.fax = this.formattedPhoneNumber(this.facilityDetail.fax);
    this.facilityDetail.customerServicePhone = this.formattedPhoneNumber(this.facilityDetail.customerServicePhone);
    this.facilityDetail.tollFreePhone = this.formattedPhoneNumber(this.facilityDetail.tollFreePhone);

    this.loadingPage = false;
  }

  isNew() {
    return !this.$route.params.facilityCode;
  }

  validateFormForSave() {
    if(!this.facilityDetail.timeZone)
      this.validator.setErrors({"timezone": ["You must provide an timezone"]});
    if(!this.facilityDetail.serviceType)
      this.validator.setErrors({"serviceType": ["You must provide an service type"]});
    
      this.validator.validate().then(isValid => {
        if(isValid)
          this.save();
      });
  }

  async save() {
    this.loading = true;

    let request: SaveFacilityDetails = JSON.parse(JSON.stringify(this.facilityDetail));
    request.isNew = request.facilityCode==null;

    request.isNew = this.isNew();

    await systemModule
      .SaveFacilityDetails(request)
      .then(response => {
        notifications.success("Facility saved", "Facility changes saved");
        if (request.isNew) 
          this.$router.push(`/admin/facility/${response.facilityCode}`);
        else
        this.loadFacility();
      })
      .catch(ex => {
        console.log(ex);
        notifications.error("Save Facility", "Failed to save facility", ex);
      })
      .finally(() => {
        this.loading = false;
      });
  }
}
